module.exports = __webpack_public_path__ + "static/pic3-8977d6fe57ca928648eaa7e4a70bbdb4.jpg";